import type {
  CreateParams,
  CreateResult,
  DataProvider,
  DeleteManyParams,
  DeleteManyResult,
  DeleteParams,
  DeleteResult,
  GetListParams,
  GetListResult,
  GetManyParams,
  GetManyReferenceParams,
  GetManyReferenceResult,
  GetManyResult,
  GetOneParams,
  GetOneResult,
  RaRecord,
  UpdateManyParams,
  UpdateManyResult,
  UpdateParams,
  UpdateResult,
} from 'react-admin';

export const createCalendarEventsDataProvider = (dataProvider: DataProvider): DataProvider => {
  return {
    getList: async (resource: string, params: GetListParams): Promise<GetListResult> => {
      const { meta, filter } = params;
      const { calendar_ids: ids } = meta;
      if (ids === undefined || ids.length === 0) return { data: [], total: 0 };
      const filters = {
        ...filter,
        meta: { ...filter.meta, sorting: { disableSorting: true } },
      };
      return dataProvider.getList(resource, { ...params, filter: filters });
    },
    getOne: async (resource: string, params: GetOneParams<RaRecord>): Promise<GetOneResult> =>
      dataProvider.getOne(resource, params),
    getMany: async (resource: string, params: GetManyParams): Promise<GetManyResult> =>
      dataProvider.getMany(resource, params),
    getManyReference: async (resource: string, params: GetManyReferenceParams): Promise<GetManyReferenceResult> =>
      dataProvider.getManyReference(resource, params),
    create: async (resource: string, params: CreateParams): Promise<CreateResult> => {
      return dataProvider.create(resource, params);
    },
    update: async (resource: string, params: UpdateParams<RaRecord>): Promise<UpdateResult> =>
      dataProvider.update(resource, params),
    updateMany: async (resource: string, params: UpdateManyParams): Promise<UpdateManyResult> =>
      dataProvider.updateMany(resource, params),
    delete: async (resource: string, params: DeleteParams<RaRecord>): Promise<DeleteResult> =>
      dataProvider.delete(resource, params),
    deleteMany: async (resource: string, params: DeleteManyParams<RaRecord>): Promise<DeleteManyResult> =>
      dataProvider.deleteMany(resource, params),
  };
};
